import { editorModes } from '@/configuration/pages/ConfigurationPage/CommunicationsConfiguration/EmailTemplates/EmailTemplateDetailConfiguration/EditorModeSelector/constants'

export const contentTabs = {
  write: 'write',
  contentBlocks: 'contentBlocks',
  preview: 'preview',
}

const previewTab = { label: 'Vista previa', value: contentTabs.preview }

export const contentTabsByMode = {
  [editorModes.html]: [
    { label: 'Escribir', value: contentTabs.write },
    { label: 'Bloques de contenido', value: contentTabs.contentBlocks },
    previewTab,
  ],
  [editorModes.liquid]: [{ label: 'Código', value: contentTabs.write }, previewTab],
}
